import { lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";

import MainRoutes from "./MainRoutes";
import Loadable from "components/loadable";
import { authenticateUser } from "features/components/helperFunctions";
import { useSelector } from "store";

const LoginPage = Loadable(lazy(() => import("features/auth/login")));
const BusinessListing = Loadable(
  lazy(() => import("features/businessListing"))
);
const SignUp = Loadable(lazy(() => import("features/auth/signup")));
const ForgotPassword = Loadable(
  lazy(() => import("features/auth/forgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("features/auth/resetPassword"))
);

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const { permittedRoutes } = useSelector((state) => state.accessManagement);

  const redirectAccessModule = (flag = "") => {
    if (flag === "BusinessListing") {
      return localStorage.getItem("allBusinessesInfo") ? (
        // if user have multiple businesses
        <BusinessListing />
      ) : (
        // if user has single business
        <Navigate to={permittedRoutes[0]} />
      );
    } else {
      if (localStorage.getItem("businessInfo")) {
        return <Navigate to={permittedRoutes[0]} />;
      } else if (localStorage.getItem("allBusinessesInfo")) {
        return <Navigate to={"/business"} />;
      } else {
        return <Navigate to={"/"} />;
      }
    }
  };

  return useRoutes([
    {
      path: "/",
      element: authenticateUser() ? redirectAccessModule() : <LoginPage />,
    },
    {
      path: "/business",
      element: authenticateUser() ? (
        redirectAccessModule("BusinessListing")
      ) : (
        <Navigate to={"/"} />
      ),
    },
    {
      path: "/signup",
      element: authenticateUser() ? redirectAccessModule() : <SignUp />,
    },
    {
      path: "/forgotPassword",
      element: authenticateUser() ? redirectAccessModule() : <ForgotPassword />,
    },
    {
      path: "/reset-password",
      element: authenticateUser() ? redirectAccessModule() : <ResetPassword />,
    },
    MainRoutes,
  ]);
}
